import {
  EventOpenEditFlowData,
  EventOpenEntityData,
  EventOpenEntityGroupData,
  EventOpenPeopleBoardData,
  EventOpenFileData,
  EventOpenPerformanceData,
  EventOpenPerformanceReportData,
  EventOpenPerformanceReportBuilderData,
  EventOpenSelectedEcosystem,
  EventOpenWorkboardData,
  EventOpenWorkData,
  EventOpenWorkflowsData,
  EventOpenWorkVideoCallData,
  Events,
  LocalStorageKey,
  localStorageUtil,
  addQueriesToUrlPath,
  useEvents,
} from '@diana/core';
import { routeUrls } from '../app/Routing/RouteUrls';
import { useNavigate } from 'react-router-dom';

export function useAppEvents() {
  const navigate = useNavigate();
  return useEvents(
    (ctx) => {
      Events.OpenFile.attach(ctx, (params: EventOpenFileData) => {
        window.open(routeUrls.legacyOpenFile.url(params, {}), '_blank');
      });

      Events.OpenWork.attach(ctx, (params: EventOpenWorkData) => {
        if (params.openInNewTab) {
          window.open(routeUrls.work.url(params, {}), '_blank');
        } else {
          navigate(routeUrls.work.url(params, {}));
        }
      });

      Events.OpenWorkflows.attach(ctx, (params: EventOpenWorkflowsData) => {
        if (params.openInNewTab) {
          window.open(routeUrls.workflows.url(params, {}), '_blank');
        } else {
          navigate(routeUrls.workflows.url(params, {}));
        }
      });

      Events.OpenWorkboard.attach(ctx, (params: EventOpenWorkboardData) => {
        const workboardUrl = addQueriesToUrlPath({
          path: routeUrls.workboard.url(params, null),
          queries: params?.queries,
        });

        if (params.openInNewTab) {
          window.open(workboardUrl, '_blank');
        } else {
          navigate(workboardUrl);
        }
      });

      Events.OpenWorkVideoCall.attach(ctx, (params: EventOpenWorkVideoCallData) => {
        if (params.openInNewTab) {
          window.open(routeUrls.workVideoChat.url(params, {}), '_blank');
        } else {
          navigate(routeUrls.workVideoChat.url(params, {}));
        }
      });

      Events.OpenPerformance.attach(ctx, (params: EventOpenPerformanceData) => {
        if (params.openInNewTab) {
          window.open(routeUrls.performance.url(params, null), '_blank');
        } else {
          navigate(routeUrls.performance.url(params, null));
        }
      });

      Events.OpenPerformanceReport.attach(ctx, (params: EventOpenPerformanceReportData) => {
        if (params.openInNewTab) {
          window.open(routeUrls.performanceReport.url(params, null), '_blank');
        } else {
          navigate(routeUrls.performanceReport.url(params, null));
        }
      });

      Events.OpenPerformanceReportBuilder.attach(
        ctx,
        (params: EventOpenPerformanceReportBuilderData) => {
          if (params.openInNewTab) {
            window.open(routeUrls.performanceReportBuilder.url(params, null), '_blank');
          } else {
            navigate(routeUrls.performanceReportBuilder.url(params, null), {
              state: { fromPathName: window.location.pathname },
            });
          }
        },
      );

      Events.OpenEntity.attach(ctx, (params: EventOpenEntityData) => {
        if (params.openInNewTab) {
          window.open(routeUrls.thing.url(params, null), '_blank');
        } else {
          navigate(routeUrls.thing.url(params, null));
        }
      });

      Events.OpenEntityGroup.attach(ctx, (params: EventOpenEntityGroupData) => {
        const thingsUrl = addQueriesToUrlPath({
          path: routeUrls.things.url(params, null),
          queries: params?.queries,
        });

        if (params.openInNewTab) {
          window.open(thingsUrl, '_blank');
        } else {
          navigate(thingsUrl);
        }
      });

      Events.OpenPeopleBoard.attach(ctx, (params: EventOpenPeopleBoardData) => {
        const peopleUrl = addQueriesToUrlPath({
          path: routeUrls.people.url(params, null),
          queries: params?.queries,
        });

        if (params.openInNewTab) {
          window.open(peopleUrl, '_blank');
        } else {
          navigate(peopleUrl);
        }
      });

      Events.OpenEditFlow.attach(ctx, (params: EventOpenEditFlowData) => {
        const url = routeUrls.flowBuilder.url(params, {
          flowResourceType: params.flowResourceType,
        });
        if (params.openInNewTab) {
          window.open(url, '_blank');
        } else {
          navigate(url, { state: { fromPathName: window.location.pathname } });
        }
      });

      Events.OpenSelectedEcosystem.attach(ctx, (params: EventOpenSelectedEcosystem) => {
        navigate(routeUrls.root.url({ environment: params.name }, null));
      });

      Events.OpenEcosystemCreate.attach(ctx, () => {
        navigate(routeUrls.createEcosystem.url(null, null));
      });

      Events.OpenPrintContext.attach(ctx, (params) => {
        if (params.openInNewTab) {
          window.open(routeUrls.workPrint.url(params, null), '_blank');
        } else {
          navigate(routeUrls.workPrint.url(params, null));
        }
      });

      Events.OpenUser.attach(ctx, (params) => {
        if (params.openInNewTab) {
          window.open(routeUrls.user.url(params, null), '_blank');
        } else {
          navigate(routeUrls.user.url(params, null));
        }
      });

      Events.OpenAsset.attach(ctx, (params) => {
        navigate(routeUrls.asset.url(params, null));
      });

      Events.OpenCheckout.attach(ctx, (params) => {
        const { priceId, redirectSuccessPath } = params;

        localStorageUtil.setItem({ key: LocalStorageKey.billingPriceId, value: priceId });

        if (redirectSuccessPath) {
          localStorageUtil.setItem({
            key: LocalStorageKey.billingRedirectSuccess,
            value: redirectSuccessPath,
          });
        }

        navigate(routeUrls.checkout.url(null, null));
      });
    },
    [navigate],
  );
}
